import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'birthday',
    'lastname',
    'pesel',
    'submitButton',
  ];

  static values = { confirmationMessage: String };

  initialize() {
    this.initialValues = this.currentValues();

    this.birthdayTargets.forEach((target) => {
      $(target).offon('select2:select', () => {
        let event = new Event('change', { bubbles: true });
        target.dispatchEvent(event);
      });
    });
  }

  handleMessage() {
    if (JSON.stringify(this.initialValues) === JSON.stringify(this.currentValues())) {
      delete this.submitButtonTarget.dataset.confirm;
    } else {
      this.submitButtonTarget.dataset.confirm = this.confirmationMessageValue;
    }
  }

  currentValues() {
    const values = {
      birthday: this.birthdayTargets.map((target) => target.value),
      lastname: this.lastnameTarget.value,
    };

    if (this.hasPeselTarget) {
      values.pesel = this.peselTarget.value;
    }

    return values;
  }
}
